import React from "react";
import { Link } from "@astryxdesign/core";
import type { LinkProps } from "@astryxdesign/core";
import styles from "./AuthLink.module.css";

export type AuthLinkProps = Omit<LinkProps, "className" | "xstyle">;

/**
 * Astryx's `Link` in the signed-out screens' ink colour. Takes the same
 * props; MUST be rendered inside an `AuthLayout`.
 */
const AuthLink = (props: AuthLinkProps): React.ReactElement => {
  return <Link {...props} className={styles.link} />;
};

export default AuthLink;
